import Link from 'next/link'
import classNames from 'classnames'
import { Feature, Work, TrackType } from '@prisma/client'
import { useTenantFeatures, WorkWithPlayers } from '@src/lib/apiClient'
import { MediaPlayerListItem } from '@src/components/MediaPlayerListItem'
import { AudioDescription, AudioOn } from '@src/components/icons'


interface WorkListItemProps {
  work: WorkWithPlayers | Work;
  adminView?: boolean;
  titleIsBold?: boolean; // active when work is playing, etc
  settingsLink?: boolean;
}

export const WorkListItem: React.FC<WorkListItemProps> = ({
  work,
  adminView,
  titleIsBold,
  settingsLink,
}) => {
  const { mediaPlayers: players, tracks } = (work as WorkWithPlayers)
  const { data: features } = useTenantFeatures()
  let audioIcon = null
  if (adminView && tracks && tracks.length > 0) {
    audioIcon = tracks[0].trackType === TrackType.AUDIO_DESCRIPTION
      ? <AudioDescription />
      : <AudioOn />
  }

  return (
    <div
      key={work.id}
      className={classNames('work-list-item', { inactive: !work.isActive, text__active: titleIsBold })}
    >
      <div className={classNames('horizontal-links')}>
        <Link
          legacyBehavior
          href={`/${settingsLink ? 'admin/' : ''}work/${work.id}`}
        >
          <a
            className="quill-content-inline work-title-link"
            dangerouslySetInnerHTML={{ __html: work.title }}
          />

        </Link>
        {audioIcon}
        {
          adminView && features?.includes(Feature.REALTIME_CONTROLS) && (
            <Link legacyBehavior href={`/admin/work/${work.id}/control`}>
              <a className="edit-link">[controls]</a>
            </Link>
          )
        }
      </div>
      {
        adminView && !!players?.length && (
          <div className="inline-media-player-list">
            {
              players?.map((mp) => (
                <MediaPlayerListItem key={mp.id} mediaPlayer={mp} work={work} />
              ))
            }
          </div>
        )
      }
    </div>
  )
}
